import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule} from '@angular/core';
import { HttpBaseUrlProvider } from './providers';
import { HttpService } from './services';

@NgModule({
  imports: [CommonModule, HttpClientModule],
})
export class SharedHttpModule {
  public static forRoot(config: { urlProvider: any }): ModuleWithProviders {
    return {
      ngModule: SharedHttpModule,
      providers: [
        HttpService,
        {
          provide: HttpBaseUrlProvider,
          useClass: config.urlProvider,
        },
      ],
    };
  }
}
